import React, { Component } from "react";
import PropTypes from "prop-types";
import { format } from "d3-format";
import displayValuesFor from "./displayValuesFor";
import GenericChartComponent from "../GenericChartComponent";

import { isDefined, functor } from "../utils";
import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";

// Tooltip do Canal de Regressão Linear (FML.LinRegr) — overlay, 3 linhas
// (Upper/A/Lower) na janela final. yAccessor(d) retorna { top, middle, bottom }.
class LinRegrChannelTooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }
  renderSVG(moreProps) {
    const {
      onClick,
      displayFormat,
      yAccessor,
      options,
      textFill,
      labelFill,
      fontFamily,
      fontSize,
    } = this.props;
    const { displayValuesFor } = this.props;

    const {
      chartConfig: { width, height },
    } = moreProps;

    const currentItem = displayValuesFor(this.props, moreProps);

    let top, middle, bottom;
    top = middle = bottom = "n/a";
    if (isDefined(currentItem) && isDefined(yAccessor(currentItem))) {
      const item = yAccessor(currentItem);
      top = displayFormat(item.top);
      middle = displayFormat(item.middle);
      bottom = displayFormat(item.bottom);
    }

    const { origin: originProp } = this.props;
    const origin = functor(originProp);
    const [x, y] = origin(width, height);

    const { period, percent } = options;
    const tooltipLabel = `LinRegr(${period}, ${percent}): `;
    const tooltipValue = `${top}, ${middle}, ${bottom}`;

    return (
      <g
        transform={`translate(${x}, ${y})`}
        className={this.props.className}
        onClick={onClick}
        data-evo-id="tooltip-linregr-channel"
      >
        <ToolTipText x={0} y={0} fontFamily={fontFamily} fontSize={fontSize}>
          <ToolTipTSpanLabel fill={labelFill}>{tooltipLabel}</ToolTipTSpanLabel>
          <tspan fill={textFill}>{tooltipValue}</tspan>
        </ToolTipText>
      </g>
    );
  }
  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

LinRegrChannelTooltip.propTypes = {
  className: PropTypes.string,
  yAccessor: PropTypes.func.isRequired,
  displayValuesFor: PropTypes.func,
  displayFormat: PropTypes.func.isRequired,
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
  onClick: PropTypes.func,
  options: PropTypes.shape({
    period: PropTypes.number,
    percent: PropTypes.number,
  }).isRequired,
  textFill: PropTypes.string,
  labelFill: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
};

LinRegrChannelTooltip.defaultProps = {
  className: "react-stockcharts-tooltip react-stockcharts-linregr-tooltip",
  displayFormat: format(".2f"),
  displayValuesFor: displayValuesFor,
  origin: [0, 10],
};

export default LinRegrChannelTooltip;
